import { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import logo from "../assets/main logo.png";

export default function Navbar({ onBookNow }) {
    const [isOpen, setIsOpen] = useState(false);
    const toggleMenu = () => setIsOpen(!isOpen);

    return (
        <nav className="fixed top-0 left-0 w-full z-50 backdrop-blur-md shadow-[0_2px_20px_rgba(0,0,0,0.4)]">
            <div
                className="w-full border-b bg-brandDarkGreen border-b-2 border-brandLightGreen"
            >
                <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
                    {/* --- Logo --- */}
                    <div className="flex-1 flex justify-center md:justify-start">
                        <img
                            src={logo}
                            alt="Amantranaa Logo"
                            onClick={() => {
                                if (window.location.pathname === "/") {
                                    window.scrollTo({ top: 0, behavior: "smooth" });
                                } else {
                                    window.location.href = "/";
                                }
                            }}
                            className="h-14 w-auto cursor-pointer rounded-md transition-transform duration-300 hover:scale-105 drop-shadow-[0_0_10px_rgba(212,175,55,0.3)]"
                        />
                    </div>

                    {/* --- Desktop Links --- */}
                    <ul className="hidden md:flex space-x-10 font-[Playfair_Display] tracking-wide text-lg items-center">
                        {["ABOUT", "SERVICES", "MENU", "GALLERY", "CONTACT"].map((item) => (
                            <li key={item}>
                                <a
                                    href={`#${item.toLowerCase()}`}
                                    className="relative group text-brandWhite hover:text-brandLightGreen transition-colors duration-300"
                                >
                                    <span>{item}</span>
                                    <span className="absolute left-0 -bottom-1 w-0 h-[2px] bg-brandLightGreen transition-all duration-300 group-hover:w-full"></span>
                                </a>
                            </li>
                        ))}

                        {/* --- Book Now Button --- */}
                        <li>
                            <button
                                onClick={onBookNow}
                                className="ml-4 px-5 py-2 rounded-full text-brandDarkGreen font-semibold
                bg-brandLightGreen
                hover:scale-105 transition-transform duration-300 shadow-[0_4px_15px_rgba(169,223,191,0.3)]"
                            >
                                Book Now
                            </button>
                        </li>
                    </ul>

                    {/* --- Mobile Menu Button --- */}
                    <div className="absolute right-6 md:hidden">
                        <button
                            onClick={toggleMenu}
                            className="text-brandLightGreen text-3xl focus:outline-none"
                        >
                            {isOpen ? <FaTimes /> : <FaBars />}
                        </button>
                    </div>
                </div>
            </div>

            {/* --- Mobile Dropdown Menu --- */}
            {isOpen && (
                <div
                    className="md:hidden absolute top-20 left-0 w-full backdrop-blur-xl border-t shadow-lg animate-slideDown"
                    style={{
                        background: "#1E3A2E", // Dark Green
                        borderTop: "1px solid #A9DFBF",
                    }}
                >
                    <ul className="flex flex-col items-center space-y-6 py-8 text-white font-[Playfair_Display] text-lg">
                        {["ABOUT", "SERVICES", "MENU", "GALLERY", "CONTACT"].map((item) => (
                            <li key={item}>
                                <a
                                    href={`#${item.toLowerCase()}`}
                                    onClick={() => setIsOpen(false)}
                                    className="hover:text-[#A9DFBF] transition-colors duration-300"
                                >
                                    {item}
                                </a>
                            </li>
                        ))}

                        {/* --- Book Now for Mobile --- */}
                        <li>
                            <button
                                onClick={() => {
                                    setIsOpen(false);
                                    onBookNow();
                                }}
                                className="mt-4 px-6 py-3 rounded-full text-[#1E3A2E] font-semibold
                bg-[#A9DFBF]
                hover:scale-105 transition-transform duration-300 shadow-[0_4px_20px_rgba(169,223,191,0.4)]"
                            >
                                Book Now
                            </button>
                        </li>
                    </ul>
                </div>
            )}
        </nav>
    );
}
